module.exports = __webpack_public_path__ + "static/media/ZCC.e9aff9e1.pdf";